<div style="margin-bottom: 10px">
  <a class="create-button" [link]="'/host/products/add'" [routerLink]="'/host/products/add'">
    <button style="margin-right: 5px" class="nnb-btn-md nnb-btn-primary">상품 개설</button>
  </a>
</div>
<ngx-table
  *ngIf="isDesktop"
  [id]="'host-product-table'"
  [configuration]="config"
  [data]="hostedProducts"
  [columns]="columns"
  [pagination]="pagination"
  (event)="onTableEvent($event)"
>
  <ng-template let-row let-index="index">
    <td>
      <div style="display: flex; align-items: center; gap: 5px">
        <div>{{ (pagination.offset-1) * pagination.limit + (index+1) }}</div>
      </div>
    </td>
    <td>
      <button
        class="nnb-btn-secondary nnb-btn-sm"
        *ngIf="reviewConfirms(row).length > 0"
        (click)="showChecks(row, checkTpl)"
      >
        승인/반려내역
      </button>
    </td>
    <td>
      <div class="nnb-badge nnb-badge-blue" *ngIf="row.isBusiness">비즈니스 상품</div>
      <div class="nnb-badge nnb-badge-green" *ngIf="!row.isBusiness">벙개모임</div>
    </td>
    <td>
      <img
        *ngIf="row.representationPhotos && row.representationPhotos.length > 0"
        [src]="row.representationPhotos?.[0]?.photo"
        style="height: 48px; min-width: 48px; border-radius: 10px"
      />
      <div
        *ngIf="!row.representationPhotos || row.representationPhotos.length === 0"
        style="width: 48px; height: 48px; background-color: #f5f5f5; border-radius: 10px"
      ></div>
    </td>
    <td>
      <ng-container *ngTemplateOutlet="statusBadge; context: { row: row }"></ng-container>
    </td>
    <td>
      <ng-container *ngTemplateOutlet="titleCell; context: { row: row }"></ng-container>
    </td>
    <td>
      <div style="display: flex; gap: 3px; align-items: center">
        <ng-container *ngTemplateOutlet="actionButtons; context: { row: row }"></ng-container>
      </div>
    </td>
    <td>
      <div class="desc">
        {{ row.createdAt|date:'yyyy-MM-dd HH:mm' }}<br />{{ row.updatedAt|date:'yyyy-MM-dd HH:mm' }}
      </div>
    </td>
  </ng-template>
</ngx-table>

<!-- 모바일: 8열 표는 폰 폭에서 가로 스크롤로 잘려 카드 리스트로 전환(host-payment 모바일 카드 관례) -->
<ng-container *ngIf="!isDesktop">
  <empty *ngIf="productsError" [label]="'상품 목록을 불러오지 못했습니다. 잠시 후 다시 시도해주세요.'"></empty>
  <ng-container *ngIf="!productsError && hostedProducts && meta">
  <div
    class="mobile-card"
    *ngFor="let row of hostedProducts | paginate: {
      id: meta.paginationId,
      itemsPerPage: meta.itemsPerPage,
      currentPage: meta.currentPage,
      totalItems: meta.totalItems
    }"
  >
    <div class="card-badges">
      <div class="nnb-badge nnb-badge-blue" *ngIf="row.isBusiness">비즈니스 상품</div>
      <div class="nnb-badge nnb-badge-green" *ngIf="!row.isBusiness">벙개모임</div>
      <ng-container *ngTemplateOutlet="statusBadge; context: { row: row }"></ng-container>
    </div>
    <div class="card-title-row">
      <img
        *ngIf="row.representationPhotos && row.representationPhotos.length > 0"
        [src]="row.representationPhotos?.[0]?.photo"
        class="thumb"
      />
      <div *ngIf="!row.representationPhotos || row.representationPhotos.length === 0" class="thumb thumb-empty"></div>
      <ng-container *ngTemplateOutlet="titleCell; context: { row: row }"></ng-container>
    </div>
    <div class="kv-row">
      <span class="kv-label">생성일 / 수정일</span>
      <span>{{ row.createdAt|date:'yyyy-MM-dd' }} / {{ row.updatedAt|date:'yyyy-MM-dd' }}</span>
    </div>
    <div class="kv-row" *ngIf="reviewConfirms(row).length > 0">
      <span class="kv-label">승인/반려 내역</span>
      <button class="nnb-btn-secondary nnb-btn-sm" (click)="showChecks(row, checkTpl)">승인/반려내역</button>
    </div>
    <div class="card-actions">
      <ng-container *ngTemplateOutlet="actionButtons; context: { row: row }"></ng-container>
    </div>
  </div>
  <empty *ngIf="hostedProducts.length === 0" [label]="'아직 상품이 없습니다.'"></empty>
  <pagination
    *ngIf="hostedProducts.length > 0"
    (onChange)="pageChanged($event)"
    [paginationId]="meta.paginationId"
  ></pagination>
  </ng-container>
</ng-container>

<!-- 작성 중 카드는 색·문구·버튼 수로 완성 카드와 갈린다 — 같은 모양이면 호스트가 배지·썸네일을 눌러 열려고 한다. -->
<ng-template #statusBadge let-row="row">
  <div *ngIf="row.isDraft; else liveStatus" class="nnb-badge nnb-badge-orange">작성 중</div>
  <ng-template #liveStatus>
    <button
      *ngIf="canToggleStatus(row); else plainStatus"
      type="button"
      class="nnb-badge status-toggle"
      [ngClass]="'nnb-badge-' + getStatusBadge(row.status).badge"
      [attr.aria-label]="toggleStatusLabel(row)"
      [title]="toggleStatusLabel(row)"
      (click)="toggleStatus(row)"
    >
      {{ row.status }}
    </button>
    <ng-template #plainStatus>
      <button
        *ngIf="statusBlockReason(row); else staticStatus"
        type="button"
        class="nnb-badge status-info"
        [ngClass]="'nnb-badge-' + getStatusBadge(row.status).badge"
        [attr.aria-label]="statusBadgeAriaLabel(row)"
        (click)="onStatusBadgeClick(row)"
      >{{ displayStatusLabel(row) }}</button>
      <ng-template #staticStatus>
        <div class="nnb-badge" [ngClass]="'nnb-badge-' + getStatusBadge(row.status).badge">
          {{ displayStatusLabel(row) }}
        </div>
      </ng-template>
    </ng-template>
  </ng-template>
</ng-template>

<ng-template #titleCell let-row="row">
  <ng-container *ngIf="row.isDraft; else liveTitle">
    <span class="draft-title">{{ displayTitle(row) }}</span>
  </ng-container>
  <ng-template #liveTitle>
    <a [href]="mainDomainUrl + '/tabs/meeting-detail/' + row.id" target="nnb-web">{{ displayTitle(row) }}</a>
  </ng-template>
</ng-template>

<ng-template #actionButtons let-row="row">
  <ng-container *ngIf="row.isDraft; else liveActions">
    <button class="nnb-btn-primary nnb-btn-sm" (click)="edit(row.id)">이어서 작성</button>
  </ng-container>
  <ng-template #liveActions>
    <button class="nnb-btn-outline nnb-btn-sm" (click)="goToTicket(row.id)">일정관리</button>
    <button *ngIf="row.isBusiness" class="nnb-btn-outline nnb-btn-sm" (click)="edit(row.id)">수정</button>
  </ng-template>
  <button class="nnb-btn-red nnb-btn-sm" (click)="removeProduct(row.id)">삭제</button>
</ng-template>

<ng-template #checkTpl>
  <div class="modal-header">
    <p class="modal-title pull-left">검토 내역</p>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body" style="padding: 30px">
    <div style="margin-top: 10px; height: 500px; overflow-y: auto">
      <table class="table">
        <tr>
          <td>검토 일시</td>
          <td>결과</td>
          <td>반려 사유</td>
        </tr>
        <tr *ngFor="let confirm of reviewConfirms(selectedProduct); let index=index">
          <td class="desc">{{ confirm.createdAt|date:'yyyy-MM-dd HH:mm' }}</td>
          <td>
            <div *ngIf="confirm.isConfirm" class="nnb-badge nnb-badge-green">승인</div>
            <div *ngIf="!confirm.isConfirm" class="nnb-badge nnb-badge-red">반려</div>
          </td>
          <td class="pre-wrap">{{ confirm.rejectComment }}</td>
        </tr>
      </table>
    </div>
  </div>
</ng-template>
